var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34037_53670)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2417 2.33393L16.146 11.1368C16.7667 12.2524 16.8356 13.3375 16.3376 14.1857C15.8395 15.0339 14.8586 15.5 13.5712 15.5H3.76274C2.47537 15.5 1.49452 15.0339 0.996435 14.1857C0.498346 13.3375 0.567312 12.2601 1.18801 11.1368L6.09226 2.33393C6.75127 1.14952 7.66315 0.5 8.66699 0.5C9.67083 0.5 10.5827 1.14952 11.2417 2.33393ZM9.41699 4C9.41699 3.58579 9.08121 3.25 8.66699 3.25C8.25278 3.25 7.91699 3.58579 7.91699 4V8C7.91699 8.41421 8.25278 8.75 8.66699 8.75C9.08121 8.75 9.41699 8.41421 9.41699 8V4ZM8.66699 11.25C8.25278 11.25 7.91699 11.5858 7.91699 12C7.91699 12.4142 8.25278 12.75 8.66699 12.75H8.67699C9.09121 12.75 9.42699 12.4142 9.42699 12C9.42699 11.5858 9.09121 11.25 8.67699 11.25H8.66699Z",
    fill: "#F5C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34037_53670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.54f8f4f60a139a6064b65cdaa8ebf1fb.svg";
export { ForwardRef as ReactComponent };